export default "__VITE_ASSET__Cz0LnhU5__"